function isObjectNotEmpty(obj) {
    return (obj != null && typeof(obj) === 'object' && Object.keys(obj).length !== 0);
}

function isStringEmpty(str) {
    str = (undefined === str || str == null) ? "" : String(str).trim();
    return (str === "");
}

function isValidEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
}

function isValidURL(url) {
    const re = new RegExp('^(https?:\\/\\/)?' // protocol
        + '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' // domain name
        + '((\\d{1,3}\\.){3}\\d{1,3}))' // OR ip (v4) address
        + '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' // port and path
        + '(\\?[;&a-z\\d%_.~+=-]*)?' // query string
        + '(\\#[-a-z\\d_]*)?$', 'i'); // fragment locator

    return re.test(url);
}

function parseStringOr(str, def) {
    if (undefined === def) {
        throw new Error('Function parseStringOr: Default value is required!');
    }

    str = (undefined === str || str == null) ? "" : String(str).trim();

    return (str === "") ? def : str;
}

/**
 * Formats acepting as boolean:
 *     - boolean
 *     - String(insensitive case)
 *     - Interger 1 and 0
 */
function parseBoolOr(bool, def) {
    if (undefined === def) {
        throw new Error('Function parseBoolOr: Default value is required!');
    }
    bool = String(bool).trim().toLowerCase();

    switch (bool) {
        case '1':
        case 'true':
            bool = true;
            break;

        case '0':
        case 'false':
            bool = false;
            break;

        default:
            bool = def;
            break;
    }

    return bool;
}

async function parseJsonOr(json, def) {
    if (undefined === def) {
        throw new Error('Function parseJsonOr: Default value is required!');
    }

    try {
        let type = typeof json;

        if (type === 'string') {
            json = await json.replace(/\\(.)/mg, "$1");
            json = await JSON.parse(json);
            type = typeof json;

            if (type === 'string') {
                json = await parseJsonOr(json, json);
                type = typeof json;
            }
        }

        if (type !== 'object') {
            json = def;
        }

        return json;

    }
    catch (e) {
        return def;
    }
}

function moneyFormat(price, currency) {
    price = parseFloat(price) || 0;
    currency = parseStringOr(currency, 'CAD');
    let locale = "";

    switch (currency) {
        case 'USD':
            locale = 'en-US';
            break;

        default:
            currency = 'CAD';
            locale = 'fr-CA';
            break;
    }

    let formatter = new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: currency,
    });

    return formatter.format(price);
}

function ucfirst(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
}

function randomString(length) {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    const charactersLength = characters.length;
    let result = [];

    for (let i = 0; i < length; i++) {
        result.push(characters.charAt(Math.floor(Math.random() * charactersLength)));
    }

    return result.join('');
}

async function getAddressComponents(formattedAddress) {
    let apiUrl = parseStringOr(process.env.REACT_APP_GOOGLE_MAPS_API_URL, "");

    if (apiUrl === "") {
        throw new Error('Google Maps Api Url is required!');
    }

    let apiKey = parseStringOr(process.env.REACT_APP_GOOGLE_API_KEY, "");

    if (apiKey === "") {
        throw new Error('Google Api Key is required!');
    }

    formattedAddress = parseStringOr(formattedAddress, "");

    if (formattedAddress === "") {
        return null;
    }

    formattedAddress = encodeURIComponent(formattedAddress);

    try {
        const response = await fetch(
            `${apiUrl}/geocode/json?address=${formattedAddress}&key=${apiKey}`,
            { method: 'GET' }
        );

        if (response == null || response.statusText !== "OK") {
            throw new Error('Error: Response');
        }

        let json = await response.json();

        if (json == null) {
            throw new Error('Error: Json parsed');
        }

        if (json.status !== "OK" ||
            json.results.length === 0) {
            return null;
        }

        return json.results[0];
    }
    catch (error) {
        console.log(error);
        return null;
    }
}


function createFormattedAddress(params) {
    let suite = parseStringOr(params.suite, "");
    let civic = parseStringOr(params.civic, "");
    let street = parseStringOr(params.street, "");
    let city = parseStringOr(params.city, "");
    let state = parseStringOr(params.state, "");
    let country = parseStringOr(params.country, "");
    let zip = parseStringOr(params.zip, "");
    let formattedAddress = "";

    if (civic !== "") {
        if (suite !== "") {
            formattedAddress += suite + "/";
        }

        formattedAddress += civic + " ";
    }

    if (street !== "") {
        formattedAddress += street + ", ";
    }

    if (city !== "") {
        formattedAddress += city + " ";
    }

    if (state !== "") {
        formattedAddress += state + " ";
    }

    if (zip !== "") {
        formattedAddress += zip + " ";
    }

    formattedAddress = formattedAddress.trim();

    if (country !== "") {
        formattedAddress += ", " + country;
    }

    return formattedAddress;
}

function parseGoogleAddress(geo) {
    let address = {
        suite: "",
        civic: "",
        street: "",
        streetShort: "",
        city: "",
        region: "",
        regionShort: "",
        state: "",
        stateShort: "",
        country: "",
        countryShort: "",
        zip: "",
        lat: "",
        lng: "",
        formattedAddress: ""
    };

    if (undefined !== geo.formatted_address) {
        address['formattedAddress'] = geo.formatted_address;
    }

    if (undefined !== geo.address_components) {
        for (let i = 0; i < geo.address_components.length; i ++) {
            let comp = geo.address_components[i];

            if (comp.types.indexOf("subpremise") !== -1) {
                address['suite'] = comp.long_name;
            }

            if (comp.types.indexOf("street_number") !== -1) {
                address['civic'] = comp.long_name;
            }

            if (comp.types.indexOf("route") !== -1) {
                address['street'] = comp.long_name;
                address['streetShort'] = comp.short_name;
            }

            if (comp.types.indexOf("locality") !== -1) {
                address['city'] = comp.long_name;
            }

            if (comp.types.indexOf("administrative_area_level_2") !== -1) {
                address['region'] = comp.long_name;
                address['regionShort'] = comp.short_name;
            }

            if (comp.types.indexOf("administrative_area_level_1") !== -1) {
                address['state'] = comp.long_name;
                address['stateShort'] = comp.short_name;
            }

            if (comp.types.indexOf("country") !== -1) {
                address['country'] = comp.long_name;
                address['countryShort'] = comp.short_name;
            }

            if (comp.types.indexOf("postal_code") !== -1) {
                address['zip'] = comp.long_name;
            }
        }
    }

    if (undefined !== geo.geometry &&
        undefined !== geo.geometry.location) {
        if (typeof geo.geometry.location.lat === 'function') {
            address['lat'] = geo.geometry.location.lat();
        }
        else {
            address['lat'] = geo.geometry.location.lat;
        }

        if (typeof geo.geometry.location.lng === 'function') {
            address['lng'] = geo.geometry.location.lng();
        }
        else {
            address['lng'] = geo.geometry.location.lng;
        }
    }

    return address;
}

function sanitizeFileName(fn) {
    let rfn = "";
    fn = fn.toLowerCase() || "";

    for (let i = 0; i < fn.length; i++) {
        let c = fn.substr(i, 1);
        let a = fn.charCodeAt(i);

        if (a >= 48 && a <= 57) {
            //this is ok (numbers)
        }
        else if (a >= 97 && a <= 122) {
            //this is ok (lc letters)
        }
        else if (c === ".") {
            //this is ok
        }
        else if (a === 130 || a === 136 || a === 137 || a === 138) {
            c = "e";
        }
        else if (a === 131 || a === 132 || a === 133 || a === 134 || a === 160) {
            c = "a";
        }
        else if (a === 135) {
            c = "c";
        }
        else if (a === 139 || a === 140 || a === 141  || a === 160) {
            c = "i";
        }
        else if (a === 147 || a === 148 || a === 149  || a === 162) {
            c = "o";
        }
        else if (a === 150 || a === 151 || a === 163) {
            c = "u";
        }
        else if (a === 152) {
            c = "y";
        }
        else if (a === 164) {
            c = "n";
        }
        else {
            c = "_";
        }

        rfn += c;
    }

    return rfn;
}

export {
    isObjectNotEmpty,
    isStringEmpty,
    isValidEmail,
    isValidURL,
    parseBoolOr,
    parseJsonOr,
    parseStringOr,
    getAddressComponents,
    parseGoogleAddress,
    createFormattedAddress,
    randomString,
    moneyFormat,
    ucfirst,
    sanitizeFileName,
}
